import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";
const getCart = credentials => {
    let url = apiUrlWithLang('/api/cart/')
    return axios.get(url, { params:credentials })
}

export default {
    getCart,
}